import { render, staticRenderFns } from "./EditPatientInfo.vue?vue&type=template&id=1cf22770&scoped=true"
import script from "./EditPatientInfo.vue?vue&type=script&lang=js"
export * from "./EditPatientInfo.vue?vue&type=script&lang=js"
import style0 from "vue-tel-input/dist/vue-tel-input.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./EditPatientInfo.vue?vue&type=style&index=1&id=1cf22770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf22770",
  null
  
)

export default component.exports